import { useQuery } from 'react-query'
import axios from 'axios'
import { getApiServer } from '../../utils/helpers'

export default function useGenerateReport (reportId, page, limit, body, timezone) {
  return useQuery(['report-results', reportId, page, limit, JSON.stringify(body)], async () => {
    const reportResults = await axios.post(`${getApiServer()}/reports/results/${reportId}?page=${page}&limit=${limit}`, { ...body, timezone }, { withCredentials: true })
    return reportResults.data
  }, {
    staleTime: Infinity,
    cacheTime: 2 * 60 * 1000,
    retry: 0,
    keepPreviousData: true,
    enabled: false
  })
}